import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7a8e3f07")

_pushScopeId("data-v-7a8e3f07")
const _hoisted_1 = { class: "thumbnails" }
const _hoisted_2 = { class: "label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ThumbnailSlide = _resolveComponent("ThumbnailSlide")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "thumbnail-list",
      modelValue: _ctx.slides,
      animation: 300,
      scroll: true,
      scrollSensitivity: 50,
      itemKey: "id"
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slides, (element, index) => {
        return (_openBlock(), _createBlock("div", {
          class: ["thumbnail-item droptarget", {
            'active': _ctx.slideIndex === index,
            'selected': _ctx.selectedSlidesIndex.includes(index),
          }],
          onMousedown: $event => _ctx.handleClickSlideThumbnail($event, index)
        }, [
          _createVNode("div", _hoisted_2, _toDisplayString(_ctx.fillDigit(index + 1, 2)), 1),
          _createVNode(_component_ThumbnailSlide, {
            class: "thumbnail",
            slide: element,
            size: 120
          }, null, 8, ["slide"])
        ], 42, ["onMousedown"]))
      }), 256))
    ], 8, ["modelValue"])
  ]))
})